import styled from 'styled-components';

interface collapseBodyProps {
	margin?: string;
	padding?: string;
	show?: boolean;
}

const CollapseBody = styled.div<collapseBodyProps>`
	display: inline-block;
	position: relative;
	box-sizing: border-box;
	width: 100%;
	display: none;
	padding-bottom: 16px;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	padding: 25px;
	${({ show }) =>
		show &&
		`display: block;	
	`};
	
`;
export default CollapseBody;
